import { useMemo, useRef } from "react"
import { colors, css, fonts, glyphs } from "../../Styles"

type Glyph = { glyphComp: JSX.Element, top?: number, right?: number, bottom?: number, left?: number }

export const glyph = ( glyphComp: JSX.Element, top?: number, right?: number, bottom?: number, left?: number ) => ({ glyphComp, top, right, bottom, left })

interface cardNumberDisplay_Props {
  header?: string
  value: number | string
  unit: string
  glyph: Glyph
  focus_view?: boolean
}
/**
 * NumberDisplay
 * @param header header to display above the single numberDisplay component.
 * @param value the value of the number to be displayed.
 * @param unit the unit of the value.
 * @returns a nice way to display a value/number. 
 */
export default function CardNumberDisplay ({header, value, unit, glyph, focus_view}:cardNumberDisplay_Props) {

  const glyphDefaultPlacement = { top: "50%", left: "50%", transform: "translate(-50%, -50%)" }
  const glyphSpecificPlacement = { top: glyph.top, left: glyph.left, bottom: glyph.bottom, right: glyph.right, transform: "none" }

  return (
    <div style={{ position: "relative", backgroundColor: colors.greyPrimary, borderRadius: "10px", width: "calc(50% - 5px)", height: focus_view ? "80px" : "70px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden"}}>
      
      <div style={{zIndex: "1", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
        <p style={{...fonts.header, ...(focus_view ? fonts.fontSize0 : fonts.fontSize1), color: colors.greyLightTertiary,}}>{value}</p>
        <div style={{ height: "2px", backgroundColor: colors.greySecondary, width: "50px" }}/>
        <p style={{...fonts.header, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), color: colors.greyTertiary, marginTop: "5px", width: "130px", textAlign: "center", backgroundColor: colors.transparent}}>{unit}</p>
      </div>
      
      <div style={{zIndex: "0", borderRadius: "10px", position: "absolute", width: "155px", height: focus_view ? "80px" : "70px", overflow: "hidden"}}>
        <div style={{ position: "absolute", ...((!glyph.top && !glyph.right && !glyph.bottom && !glyph.left) ? glyphDefaultPlacement : glyphSpecificPlacement) }}>
          {glyph.glyphComp}
        </div>
      </div>

    </div>
  )
}

interface cardNumberDisplayList_Props {
  headers?: string[]
  values: (number | string)[]
  units: string[]
  glyphs: Glyph[]
  focus_view?: boolean
}

export function CardNumberDisplayList({ headers, values, units, glyphs, focus_view }: cardNumberDisplayList_Props) {

  const Item_List = useMemo(() => {
    return values.map((_values, index) => {
      var _headers = headers ? headers[index] : undefined;
      var _units = units[index];
      var _glyphs = glyphs[index];

      var view = [(
        <CardNumberDisplay
          key={index}
          header={_headers}
          value={_values}
          unit={_units}
          glyph={_glyphs}
          focus_view={focus_view}
        />
      )]

      return view;
    })
  }, [values, headers, units, glyphs, focus_view])

  return (
    <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row", gap: "10px", boxSizing: "border-box", alignItems: "center", width: "100%" }}>
      {Item_List}
    </div>
  )
}
